import React from 'react'

import { Button, Form, Segment, Header, InputOnChangeData } from 'semantic-ui-react'

import PasswordInput from '../../components/common/PasswordInput'

const MyProfilePasswordTab = ({ currentPassword, newPassword, isMobile, handleChange, handleSubmit }: IProps) => {
  return (
    <>
      <Header as="h3">Change my password</Header>

      <Segment>
        <Form>
          <Form.Field>
            <label>Current password</label>
            <PasswordInput
              name="currentPassword"
              value={currentPassword || ''}
              handleChange={handleChange}
              placeholder="Type here..."
            />
          </Form.Field>

          <Form.Field>
            <label>New password</label>
            <PasswordInput
              name="newPassword"
              value={newPassword || ''}
              handleChange={handleChange}
              placeholder="Type here..."
            />
          </Form.Field>
          <Button primary onClick={handleSubmit} fluid={isMobile}>
            Update
          </Button>
        </Form>
      </Segment>
    </>
  )
}

interface IProps {
  currentPassword: string
  newPassword: string
  isMobile: boolean
  handleChange: (e: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => void
  handleSubmit: () => void
}

export default MyProfilePasswordTab
